export default function Youtube({ className, ...rest }: { className?: string }) {
  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M20.2984 7.08743C19.6487 6.31506 18.4491 6 16.1581 6H7.84177C5.49834 6 4.27841 6.33538 3.6311 7.15769C3 7.95945 3 9.14077 3 10.7757V13.892C3 17.0595 3.7488 18.6677 7.84177 18.6677H16.1581C18.1449 18.6677 19.2458 18.3897 19.958 17.7081C20.6884 17.0091 21 15.8678 21 13.892V10.7757C21 9.05152 20.9512 7.86323 20.2984 7.08743ZM14.5561 12.7641L10.7797 14.7378C10.6952 14.7819 10.6029 14.8038 10.5107 14.8038C10.4063 14.8038 10.3021 14.7757 10.2099 14.7198C10.0361 14.6146 9.93006 14.4263 9.93006 14.2232V10.2885C9.93006 10.0857 10.0359 9.89758 10.2092 9.79225C10.3827 9.68692 10.5984 9.67972 10.7783 9.77321L14.5547 11.7342C14.7469 11.8339 14.8675 12.0323 14.8678 12.2487C14.868 12.4653 14.7479 12.6639 14.5561 12.7641Z"
        fill="currentColor"
      />
    </svg>
  )
}
